import { CfgSyncPlugin } from "./CfgSyncPlugin";
export { CfgSyncPlugin };
//# sourceMappingURL=applicationinsights-cfgsync-js.js.map